import type { FlattenedCategoriesData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { MAX_COLUMNS_TO_DISPLAY } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";

export const fixedSelectedIndustryPosition = (
    categoriesData: FlattenedCategoriesData = [],
    selectedCategory: IFlattenedCategory,
): FlattenedCategoriesData => {
    if (categoriesData.length <= MAX_COLUMNS_TO_DISPLAY) {return categoriesData;}
    const selectedIndustryIndex = categoriesData.findIndex(
        (categoryData) => categoryData.Category === selectedCategory.forApi,
    );
    if (selectedIndustryIndex < MAX_COLUMNS_TO_DISPLAY - 1) {return categoriesData;}
    const selectedIndustryData = categoriesData.find(
        (categoryData) => categoryData.Category === selectedCategory.forApi,
    );
    const fixedOrderArray = [
        ...categoriesData.slice(0, MAX_COLUMNS_TO_DISPLAY - 2),
        selectedIndustryData,
        ...categoriesData.slice(MAX_COLUMNS_TO_DISPLAY - 2).filter((categoryData) => {
            return categoryData.Category !== selectedCategory.forApi;
        }),
    ];
    return fixedOrderArray;
};
